import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SharedService {
    public Data: Subject<any> = new Subject<any>();
    public documnetData: Subject<any> = new Subject<any>();
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/shared.ts